export default (props, vars) =>
  props?.['student']?.finalPresentation.source === 'loom';
